<template>
	<div class="modal-wrapper">
		<div class="accessory-container bg-white">
			<div class="flex justify-end pt-20 pr-20">
				<button class="modal-btn" @click="onClose" v-text="'X'" />
			</div>
			<div v-if="options.accessory.metadata.accessoryType" class="modal-row flex">
				<div class="accessories-img">
					<img :alt="options.accessory.description" :src="`/my/images/${options.accessory.metadata.accessoryType}.png`">
				</div>
				<div class="modal-text mt-10 ml-20 mb-20">
					<div class="modal-title small-text font-medium mb-10">
						{{ $tc(`modals.wizardAccessory.${options.accessory.metadata.accessoryType}Title`) }}
					</div>
					<div
						class="modal-body small-sm-text mr-50"
						v-html="$tc(`modals.wizardAccessory.${options.accessory.metadata.accessoryType}Description`)"
					/>
				</div>
			</div>
			<div v-else>
				<div class="mt-50 mb-50">
					<p class="text-primary text-center">
						{{ $tc('modals.wizardAccessory.failedLoadText') }} {{
							$tc(`modals.wizardAccessory.${options.accessory.metadata.accessoryType}`) }}.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardAccessory',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
	.accessory-container {
		width: 544px;
		min-height: 250px;
		border: #EEEEEE solid 6px;

		.modal-row {
			@include respond-below(phone) {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
			}
		}
	}
</style>
